<template>
    <div class="flex justify-between items-center pt-2">
        <div
            class="w-8 h-8 rounded-full cursor-pointer whitespace-no-wrap flex justify-center items-center tap-no-bgr"
            :class="decDisabled? 'bg-additional-text':'bg-brand-light'"
            @click="onDecrementClick">
            <img class="w-3 h-3" src="@/assets/SVG/minus.svg"></div>
        <p class="flex justify-center w-1/2" id="one">{{value || 0 }}
            {{declOfNum(value, countItemsNames)}}</p>
        <div class="w-8 h-8 rounded-full cursor-pointer whitespace-no-wrap flex justify-center items-center tap-no-bgr"
                :class="incDisabled? 'bg-additional-text':'bg-brand-light'"
                @click="onIncrementClick">
                <img
                class="w-3 h-3" src="@/assets/SVG/plus.svg"></div>
    </div>
</template>

<script>
export default {
  props: {
    min: {
      type: Number,
      default: 2,
    },
    max: {
      type: Number,
      default: 10,
    },
    def: {
      type: Number,
      default: 2,
    },
    countItemsNames: {
      default: () => ['игрок', 'игрока', 'игроков'],
    },
  },
  data() {
    return {
      value: this.def,
    };
  },

  computed: {
    decDisabled() {
      return this.value <= this.min;
    },

    incDisabled() {
      return this.value >= this.max;
    },

  },

  methods: {
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },

    onIncrementClick() {
      if (this.incDisabled) return;
      this.value++;
      this.updateValue();
    },

    onDecrementClick() {
      if (this.decDisabled) return;
      this.value--;
      this.updateValue();
    },

    updateValue() {
      this.$emit('input', this.value);
    },
  },

};
</script>

<style scoped>

.tap-no-bgr {
  -webkit-tap-highlight-color: transparent;
  -moz-user-select: none; -webkit-user-select: none; -ms-user-select: none; user-select: none;

}

</style>
